module.exports = __webpack_public_path__ + "img/China-hover.4f0d9926.jpg";